export default function PartnershipSection() {
  return (
    <section className="w-full bg-white py-12 md:py-16 lg:py-20 scroll-mt-20" id="partnership">
      <div className="section-container">
        {/* Section Header */}
        <div className="text-center mb-10 md:mb-14">
          <span className="text-[#E60073] text-xs tracking-[0.2em] block mb-3">● 提携・パートナーシップ</span>
          <h2 className="text-[#1A1A1A] text-2xl md:text-3xl font-bold tracking-wide">
            TBM健康美容研究所は、高崎ビューティモード専門学校のパートナー企業です
          </h2>
          <div className="w-10 h-px bg-[#E60073] mx-auto mt-4" />
        </div>

        {/* Main Partnership Card */}
        <div className="max-w-4xl mx-auto">
          <div className="bg-[#F5F5F5] border border-[#E5E5E5] rounded-lg overflow-hidden">
            <div className="flex flex-col lg:flex-row">
              {/* Left: School Info */}
              <div className="flex-1 p-6 md:p-8 lg:p-10 flex flex-col justify-center">
                <div className="mb-4">
                  <span className="inline-block bg-[#E60073]/10 text-[#E60073] text-xs font-medium px-3 py-1 rounded-full mb-3">
                    中央カレッジグループ
                  </span>
                  <h3 className="text-[#1A1A1A] text-xl md:text-2xl font-bold leading-snug">
                    高崎ビューティモード
                    <br />
                    専門学校
                  </h3>
                  <p className="text-[#666666] text-xs mt-1">
                    学校法人 有坂中央学園
                  </p>
                </div>

                <p className="text-[#333333] text-sm leading-relaxed mb-6">
                  株式会社TBM健康美容研究所は、学校法人有坂中央学園が運営する
                  <strong>高崎ビューティモード専門学校</strong>と密接に連携し、
                  美容業界の教育・人材育成において協力体制を築いています。
                  最新の美容理論と実践的な技術教育を融合し、次世代の美容プロフェッショナルを共に育成しています。
                </p>

                <div className="flex flex-col sm:flex-row gap-3">
                  <a
                    href="https://www.chuo.ac.jp/tbm/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center justify-center gap-2 bg-[#E60073] text-white text-sm font-medium px-6 py-3 rounded-md transition-all duration-300 hover:bg-[#B8005C] whitespace-nowrap"
                  >
                    <i className="ri-external-link-line text-sm"></i>
                    <span>高崎ビューティモード専門学校</span>
                  </a>
                  <a
                    href="/links"
                    className="inline-flex items-center justify-center gap-2 border border-[#E5E5E5] text-[#333333] text-sm font-medium px-6 py-3 rounded-md transition-all duration-300 hover:bg-[#F5F5F5] hover:border-[#E60073] hover:text-[#E60073] whitespace-nowrap"
                  >
                    <i className="ri-building-line text-sm"></i>
                    <span>グループ校・企業一覧</span>
                  </a>
                </div>
              </div>

              {/* Right: Visual */}
              <div className="lg:w-[380px] h-[240px] lg:h-[340px] relative flex-shrink-0 overflow-hidden">
                <img
                  src="https://media.genaiweb.ai/73acebca-6391-4da3-b270-472de16380f3/b78d9dcd.jpeg"
                  alt="高崎ビューティモード専門学校"
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-r from-transparent to-[#F5F5F5] lg:hidden" />
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Note */}
        <div className="max-w-4xl mx-auto mt-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 bg-[#F5F5F5] border border-[#E5E5E5] rounded-lg p-4 md:p-5">
          <div className="flex items-start gap-3">
            <div className="w-8 h-8 flex items-center justify-center flex-shrink-0 rounded-full bg-[#E60073]/10 text-[#E60073]">
              <i className="ri-information-line text-sm"></i>
            </div>
            <div>
              <p className="text-[#333333] text-sm font-medium">中央カレッジグループについて</p>
              <p className="text-[#666666] text-xs mt-0.5">
                全国に展開する教育機関グループ。美容・理容・医療・福祉分野で専門教育を提供しています。
              </p>
            </div>
          </div>
          <a
            href="/links"
            className="inline-flex items-center gap-1 text-[#E60073] text-sm font-medium hover:text-[#B8005C] transition-colors whitespace-nowrap flex-shrink-0"
          >
            <span>グループ校・企業一覧を見る</span>
            <i className="ri-arrow-right-line text-sm"></i>
          </a>
        </div>
      </div>
    </section>
  );
}